<template>
  <dsf-exam-layout :exam-loading="loading" :not-data="notData">
    <template #header>
      <el-row type="flex" justify="space-between">
        <el-col :span="8">
          <h3>错题练习</h3>
        </el-col>
        <el-col :span="8">
          <div class="user">{{ userName || dsf.cookies.get("user_name") }}</div>
        </el-col>
      </el-row>
    </template>
    <template #left>
      <p class="sub-title list bg pd-10">答题卡</p>
      <div class="card-list">
        <el-row class="card-tips pd-10">
          <el-col :span="8" class="a1"> 正确：{{ rightNum }} </el-col>
          <el-col :span="8" class="a2 error"> 错误：{{ unrightNum }} </el-col>
          <el-col :span="8" class="a3 not-answer"> 未答：{{ questionsNum - rightNum - unrightNum }} </el-col>
        </el-row>
        <p class="sub-title list pd-10">共{{ questionsNum }}题</p>
        <div class="question-list">
          <div
            v-for="(item, index) in questionsNum"
            :key="item"
            :class="[{ active: index == wrongExerciseNum - 1 }, allStatus[index]]"
            class="item"
            @click="go(index + 1)"
          >
            {{ index + 1 }}
          </div>
        </div>
      </div>
    </template>
    <template #main>
      <template v-if="practice.num">
        <p class="sub-title list bg pd-20" v-html="practice.items.text"></p>
        <div class="exam-content">
          <div class="question">
            <div class="left">
              <dsf-exam-item-box
                type="practice"
                :readOnly="previewStatus"
                :preview-status="previewStatus"
                :subjects="practice"
                :key="previewStatus"
                :hide-mark="true"
                :exam-index="wrongExerciseNum - 1"
              />
            </div>
          </div>
        </div>
      </template>
    </template>
    <template #right>
      <!-- <div class="item">
            <p class="txt">可练习时间</p>
            <p class="result">{{ practice.trainingDateTime }}</p>
          </div> -->
      <div class="item">
        <p class="txt">当前进度</p>
        <el-progress :percentage="percentageNumber" :format="format"></el-progress>
      </div>
      <dsf-setting-font-size />
      <div v-if="practice && wrongExerciseNum > 1" class="exam-submit">
        <el-button class="exam-post before" @click="go(wrongExerciseNum - 1)"> 上一题 </el-button>
      </div>
      <div class="exam-submit" v-if="practice">
        <el-button class="exam-post" @click="examPost">下一题</el-button>
        <!-- <el-button v-if="practice.questionsDto.showStatus" class="exam-post" @click="next()">下一题</el-button> -->
      </div>
    </template>
  </dsf-exam-layout>
</template>

<script>
export default {
  name: "ExamWrongExercise",
  provide() {
    return {
      exam: this,
    };
  },
  data() {
    return {
      loading: false,
      disabled: false,
      practice: {},
      allStatus: [],
      previewStatus: false,
      userName: "",
      alreadyAnswers: [],
      wrongExerciseNum: 1,
      nextQuestionsStatus: false,
      rightNum: 0,
      unrightNum: 0,
      questionsNum: 0,
      wrongStatus: null,
      wrongItems: null,
      wrongSource: null,
      wrongId: null,
      searchValue: null,
      notData: null,
    };
  },
  computed: {
    percentageNumber() {
      if (this.questionsNum) {
        return ((this.rightNum + this.unrightNum) * 100) / this.questionsNum;
      }
      return 0;
    },
  },
  created() {
    this.wrongStatus = this.$route.query?.status;
    this.wrongExerciseNum = this.$route.query?.num || 1;
    this.wrongItems = this.$route.query?.items;
    this.wrongSource = this.$route.query?.source;
    this.wrongId = this.$route.query?.wrongId;
    this.searchValue = this.$route.query?.searchValue;
    this.queryData();
  },
  mounted() {},
  methods: {
    queryData() {
      this.loading = true;
      let params = {
        num: this.wrongExerciseNum,
        status: this.wrongStatus,
        items: this.wrongItems,
        source: this.wrongSource,
        wrongId: this.wrongId,
        searchValue: this.searchValue,
      };
      this.$http
        .get("/error/getQuestions", params, $$webRoot.exam)
        .done((res) => {
          if (res.success) {
            // 加载放到请求接口中  不论加载状态
            this.loading = false;
            this.nextQuestionsStatus = false;
            this.previewStatus = false;
            this.questionsNum = res.data.questionsNum;
            this.practice = res.data.questionsDto;
            this.userName = res.data.uname;
            // 添加当前num
            this.practice.num = this.wrongExerciseNum;
            this.alreadyAnswers.push(this.practice);
            // console.log(this.practice);
          } else {
            if (res.state == 400114) {
              this.loading = false;
              this.notData = res.message;
            } else {
              dsf.layer.message(res.message, false);
            }
          }
        })
        .catch((err) => {
          dsf.layer.message(err.message, false);
        });
    },
    examPost() {
      if (this.disabled) {
        return;
      }
      let data = this.practice;
      if (data.items.value == "group") {
        let childAns = [];
        // 循环子级判断
        _(data.children).forEach((children) => {
          childAns.push(children.answered && _.every(children.result, Boolean));
        });
        data.answered = _.every(childAns, Boolean);
      } else {
        data.answered = data.result && _.every(data.result, Boolean) && data.answered;
      }
      if (!data.answered) {
        dsf.layer.message("此题未答，不能到下一题", false);
        return;
      }

      if (this.nextQuestionsStatus) {
        // 有没下一题
        if (this.allStatus.length == this.questionsNum && _.every(this.allStatus, Boolean)) {
          this.showConfirm();
        } else {
          // 如果最后一页面
          let examNum = _.findIndex(this.allStatus, (item) => item == null);
          if (this.allStatus.length == this.questionsNum && examNum > -1) {
            // 从索引开始重新答题
            this.wrongExerciseNum = examNum + 1;
          } else {
            this.wrongExerciseNum++;
          }
          this.go();
        }
      } else {
        this.nextQuestionsStatus = true;
        let params = [];
        // 组合题 和 普通题的参数区别
        if (data.items.value == "group") {
          _.forEach(data.children, (child) => {
            params.push({
              questionsId: child.examQuestionsId,
              items: child.items.value,
              treeinfoLevel: child.treeinfoLevel,
              treeinfoPid: child.treeinfoPid,
              results: child.result,
            });
          });
        } else {
          params.push({
            questionsId: data.examQuestionsId,
            items: data.items.value,
            treeinfoLevel: data.treeinfoLevel,
            treeinfoPid: data.treeinfoPid,
            results: data.result,
          });
        }

        //console.log("提交数据", params);

        this.disabled = true;
        this.$http
          .post(
            "/error/checkQuestion",
            JSON.stringify(params),
            {
              headers: {
                "Content-Type": "application/json",
              },
            },
            $$webRoot.exam
          )
          .done((res) => {
            this.disabled = false;
            if (res.success) {
              let resultData = null;
              let resultStatus = null;

              // 返回题 做数据处理渲染答案
              if (data.items.value == "group") {
                resultData = res.data;
                _.forEach(this.practice.children, (child, index) => {
                  let childData = resultData[index].questionsAnswerDto;
                  child.answer = childData.answer;
                  child.showStatus = true;
                });
                resultStatus = _.every(resultData, ["handleResult", "right"]) ? "right" : "error";
              } else {
                resultData = res.data[0].questionsAnswerDto;
                this.practice.answer = resultData.answer;
                resultStatus = res.data[0].handleResult;
              }
              // 答题卡 标记样式
              this.allStatus[this.wrongExerciseNum - 1] = resultStatus;
              // 如果当前题答错
              if (resultStatus !== "right") {
                // 答错加1
                this.unrightNum++;
                // 当前题不能再次选择
                this.previewStatus = true;
                // 当前题显示错误信息
                this.$set(this.practice, "showStatus", true);
              } else {
                // 正确数据加1
                this.rightNum++;
                this.examPost();
              }
              // 加入已经回答的数据
              this.alreadyAnswers.push(this.practice);
              // console.log("---", this.alreadyAnswers, this.allStatus, res.data, this.practice);

              // 刷新父级
              if (window.opener?.openerVms && window.opener.openerVms[window.name]) {
                this.$openerVm = window.opener.openerVms[window.name] || null;
                this.$openerVm?.reloadData();
              }
            } else {
              dsf.layer.message(res.message, false);
            }
          })
          .catch((err) => {
            this.disabled = false;
            dsf.layer.message(err.message, false);
          });
      }
    },
    showConfirm() {
      dsf.layer
        .confirm({
          title: "提示",
          message: "已完成所有错题,确认关闭吗？",
        })
        .done(() => {
          // 刷新父级
          if (window.opener?.openerVms && window.opener.openerVms[window.name]) {
            this.$parentOpenerVm = window.opener.openerVms[window.name] || null;
            // 刷新首页列表
            this.$parentOpenerVm?.reloadData?.();
            this.$parentOpenerVm?.init?.();
          }
          window.opener = "";
          window.close();
        })
        .catch((err) => {});
    },
    go(index) {
      this.wrongExerciseNum = index || this.wrongExerciseNum;
      // 如果已提交里面没有找到当前题 。
      let numStart = _.findIndex(this.alreadyAnswers, (item) => item.num == this.wrongExerciseNum);
      if (numStart >= 0) {
        this.practice = _.find(this.alreadyAnswers, (item) => item.num == this.wrongExerciseNum);
        let answered = this.practice.answered && this.practice.answer ? true : false;
        // 如果当前题没有答
        this.nextQuestionsStatus = this.practice.items.value == "group" ? this.practice?.answered : answered;
        // 当前题不能再次选择
        this.previewStatus = this.practice.items.value == "group" ? this.practice?.answered : answered;
      } else {
        this.queryData();
      }
    },
    format() {
      return this.rightNum + this.unrightNum + "/" + this.questionsNum;
    },
    active(index) {
      const hasAnswer = this.alreadyAnswers?.find((item) => item.num == index);
      // console.log(hasAnswer);
      return hasAnswer?.isRight || "";
    },
  },
};
</script>
